/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsGooglePublicAuthOptions interface.
 */
export function instanceOfFxIdDomainSettingsGooglePublicAuthOptions(value) {
    if (!('ClientId' in value) || value['ClientId'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsGooglePublicAuthOptionsFromJSON(json) {
    return FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ClientId': json['ClientId'],
    };
}
export function FxIdDomainSettingsGooglePublicAuthOptionsToJSON(json) {
    return FxIdDomainSettingsGooglePublicAuthOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsGooglePublicAuthOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ClientId': value['ClientId'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsGooglePublicAuthOptions.js.map